import React from "react";
import { Card, Statistic } from "antd";
import { FileExclamationOutlined } from "@ant-design/icons";

const RefundedOrdersCard = ({ value = 0 }) => {
  return (
    <Card className="dashboard-card">
      <div className="">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="card-title">ORDERS REFUNDED</h5>
          <div className="icon-box purple">
            <FileExclamationOutlined />
          </div>
        </div>
        
        <Statistic
          value={value}
          precision={0}
          valueStyle={{ color: "#cf1322", fontWeight: "bold", fontSize: "24PX" }}
        />
      </div>
    </Card>
  );
};

export default RefundedOrdersCard;
